module.exports = window.T['undefined/lineplot.html'] || "<svg class=\"bblineplot\"></svg>";